const COMMON_APP_MIN_YEAR = 1956;
const COMMON_APP_MAX_YEAR = 2031;

export const minDate = new Date(COMMON_APP_MIN_YEAR, 0);
export const maxDate = new Date(COMMON_APP_MAX_YEAR, 11);
